import { render } from "./CategoryListTable.vue?vue&type=template&id=13a8f2a2"
import script from "./CategoryListTable.vue?vue&type=script&lang=js"
export * from "./CategoryListTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__